import { ApiError } from "@/lib/api";

type MinimalRouter = { replace(href: string): void };

/**
 * Redirects to the tenant's login page when a request fails because the
 * session died mid-use (expired, or the account was deleted). Returns true
 * when it redirected, so callers can skip showing an inline error instead.
 */
export function redirectIfSessionExpired(caught: unknown, tenantCode: string, router: MinimalRouter): boolean {
  if (caught instanceof ApiError && caught.status === 401) {
    router.replace(`/${tenantCode}/login`);
    return true;
  }
  return false;
}
